import { Avatar } from './core';
import { Icon, ChevronRightIcon, PhoneIcon } from './core';

export interface CustomerCardProps {
  firstName: string;
  lastName: string;
  phone: string;
  /** Called when the card is clicked — parent handles navigation */
  onClick: () => void;
}

function getInitials(firstName: string, lastName: string): string {
  return (firstName[0] + (lastName[0] ?? '')).toUpperCase();
}

export function CustomerCard({ firstName, lastName, phone, onClick }: CustomerCardProps) {
  const initials = getInitials(firstName, lastName);

  return (
    <button
      type="button"
      onClick={onClick}
      className="transition-agrobook flex w-full items-center rounded border border-green-200 bg-white px-[18px] py-4 text-left duration-agrobook hover:-translate-y-px hover:border-green-600 hover:shadow-md"
    >
      <Avatar size="sm" variant="customer" className="me-4 shrink-0">
        {initials}
      </Avatar>

      <div className="min-w-0 flex-1">
        <p className="flex truncate font-body text-base font-semibold text-gray-900">
          {firstName} {lastName}
        </p>
        <p className="mt-0.5 flex items-center gap-1 font-body text-sm text-gray-500">
          <Icon size="xs" className="shrink-0">
            <PhoneIcon />
          </Icon>
          {phone}
        </p>
      </div>

      <Icon size="sm" className="shrink-0 text-gray-300 rtl:rotate-180">
        <ChevronRightIcon />
      </Icon>
    </button>
  );
}
